import React from 'react';
import {
    Comparison,
    MembershipComparison,
} from 'utils/components/FiltersModal/comparison/FilterComparison';
import MembershipComparisonControl from 'utils/components/FiltersModal/comparison/MembershipComparisonControl';
import { EnumMap } from '@instinet-analytics/core-lib';

export interface ComparisonGroupMembershipProps<TDataItem> {
    columnName: string;
    fieldName: string;
    enumMap?: EnumMap;
    comparison: MembershipComparison;
    data?: TDataItem[];
    staticData?: { [dimension: string]: string[] };
    setComparison?: (comparison: Comparison, commitOnSet?: boolean) => void;
    onInputEnter: () => void;
}

export default function ComparisonGroupMembership<TDataItem>(
    props: ComparisonGroupMembershipProps<TDataItem>
) {
    const {
        columnName,
        comparison,
        fieldName,
        data,
        staticData,
        enumMap,
        setComparison,
        onInputEnter,
    } = props;

    if (!comparison || !setComparison) {
        return null;
    }

    return (
        <MembershipComparisonControl
            columnName={columnName}
            fieldName={fieldName}
            data={data}
            staticData={staticData}
            valueType={comparison.valueType}
            enumMap={enumMap}
            sign={comparison.sign}
            values={comparison.values.map((x) => x as string)}
            onSignChange={(sign) =>
                setComparison({
                    ...comparison,
                    sign,
                })
            }
            onValuesChange={(values, commitOnSet) =>
                setComparison(
                    {
                        ...comparison,
                        values,
                    },
                    commitOnSet
                )
            }
            onInputEnter={onInputEnter}
        />
    );
}
